import {ErrorObject} from 'types';

/**
 * The helper to validate response
 * @param {ErrorObject | any} object
 * @return {boolean}
 */
export default function isError(
    object: ErrorObject | any,
): object is ErrorObject {
  return Boolean(object?.statusCode);
}
